import { render, staticRenderFns } from "./PostulantsList.vue?vue&type=template&id=05d84f6a&scoped=true&"
import script from "./PostulantsList.vue?vue&type=script&lang=js&"
export * from "./PostulantsList.vue?vue&type=script&lang=js&"
import style0 from "./PostulantsList.vue?vue&type=style&index=0&id=05d84f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d84f6a",
  null
  
)

export default component.exports